// --- Początek: Zarządzanie ładowaniem Google Charts Loader ---
let googleChartsLoaded = false;
let googleChartsLoadingPromise = null;

function loadGoogleChartsScript() {
    // ... (bez zmian) ...
    if (googleChartsLoaded) {
        return Promise.resolve();
    }
    if (googleChartsLoadingPromise) {
        return googleChartsLoadingPromise;
    }
    googleChartsLoadingPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://www.gstatic.com/charts/loader.js';
        script.onload = () => {
            console.info("Google Charts Loader loaded successfully.");
            googleChartsLoaded = true;
            googleChartsLoadingPromise = null;
            resolve();
        };
        script.onerror = (error) => {
            console.error("Failed to load Google Charts Loader:", error);
            googleChartsLoadingPromise = null;
            reject(error);
        };
        document.head.appendChild(script);
        console.info("Attempting to load Google Charts Loader...");
    });
    return googleChartsLoadingPromise;
}
// --- Koniec: Zarządzanie ładowaniem Google Charts Loader ---


// --- Początek: Funkcja inicjująca konkretny wykres ---
function initializeChart(containerElement) {
    // Sprawdź, czy ten konkretny kontener już został zainicjowany
    if (containerElement.dataset.chartInitialized === 'true') {
        return;
    }

    console.log("Initializing chart for container:", containerElement.id);

    const chartElementId = containerElement.dataset.chartElementId;
    const chartDataString = containerElement.dataset.chartData;
    const chartTitle = containerElement.dataset.chartTitle;
    const labelPozycja = containerElement.dataset.labelPozycja || 'Pozycja';
    const labelWartosc = containerElement.dataset.labelWartosc || 'Wartość';
    const targetDiv = document.getElementById(chartElementId); // Div gdzie rysowany jest wykres i gdzie jest loader

    // --- USUNIĘTO SEKCJE MANIPULUJĄCE contentRow i loadingIndicator ---
    // Nie pokazujemy już .resp-row (jest widoczny od początku).
    // Loader wewnątrz targetDiv zostanie zastąpiony przez wykres lub komunikat błędu.

    if (!chartElementId || !chartDataString || !targetDiv) {
        console.error("Missing data attributes or target element for chart in container:", containerElement.id);
        if(targetDiv) {
            // Ustaw komunikat błędu - to zastąpi loader wewnątrz targetDiv
            targetDiv.innerHTML = "<p style='color: red;'>Błąd konfiguracji wykresu (brak danych lub elementu docelowego).</p>";
        }
        containerElement.dataset.chartInitialized = 'true';
        return;
    }

    let data;
    try {
        data = JSON.parse(chartDataString);
        if (!Array.isArray(data) || data.length === 0) {
            console.warn("Chart data is empty for container:", containerElement.id);
            if(targetDiv) {
                // Ustaw komunikat - to zastąpi loader
                targetDiv.innerHTML = "<p>Brak danych do narysowania wykresu.</p>";
            }
            containerElement.dataset.chartInitialized = 'true';
            return;
        }
    } catch (e) {
        console.error("Error parsing chart data for container:", containerElement.id, e);
        console.error("Data string was:", chartDataString);
        if(targetDiv) {
            // Ustaw komunikat błędu - to zastąpi loader
            targetDiv.innerHTML = "<p style='color: red;'>Błąd podczas przetwarzania danych wykresu.</p>";
        }
        containerElement.dataset.chartInitialized = 'true';
        return;
    }

    // Krok 1: Upewnij się, że główny skrypt Google jest załadowany
    loadGoogleChartsScript()
        .then(() => {
            // Krok 2: Załaduj potrzebne pakiety
            google.charts.load('current', { 'packages': ['bar'] });

            // Krok 3: Ustaw funkcję zwrotną, która narysuje wykres
            google.charts.setOnLoadCallback(() => {
                console.log("Google Charts packages loaded, drawing chart:", chartElementId);
                // Wywołaj rysowanie - drawSpecificChart zastąpi zawartość targetDiv (w tym loader)
                drawSpecificChart(targetDiv, data, chartTitle, labelPozycja, labelWartosc);
                // Oznacz kontener jako zainicjowany
                containerElement.dataset.chartInitialized = 'true';
            });
        })
        .catch(error => {
            console.error("Error loading Google Charts library for container:", containerElement.id, error);
            if(targetDiv) {
                // Ustaw komunikat błędu - to zastąpi loader
                targetDiv.innerHTML = "<p style='color: red;'>Nie można załadować biblioteki wykresów Google.</p>";
            }
            containerElement.dataset.chartInitialized = 'true';
        });
}
// --- Koniec: Funkcja inicjująca konkretny wykres ---


// --- Początek: Funkcja rysująca wykres (wywoływana przez initializeChart) ---
function drawSpecificChart(targetDiv, data, chartTitle, labelPozycja, labelWartosc) {
    // ... (Funkcja drawSpecificChart pozostaje bez zmian) ...
    // Ważne: chart.draw() lub ustawienie targetDiv.innerHTML w bloku catch
    // zastąpią zawartość diva, w tym wskaźnik ładowania.
    try {
        var dataTableArray = [];
        dataTableArray.push([labelPozycja, labelWartosc]);

        data.forEach(item => {
            let numericValue = parseFloat(item.Wartosc);
            if (isNaN(numericValue)) {
                console.warn(`Invalid numeric value found for item '${item.Pozycja}'. Setting to 0.`, item);
                numericValue = 0;
            }
            dataTableArray.push([item.Pozycja, numericValue]);
        });

        var dataTable = google.visualization.arrayToDataTable(dataTableArray);

        var options = {
            backgroundColor: 'transparent',
            bar: { groupWidth: "85%" },
            legend: { position: "none" },
            height: 400,
            width: "100%",
            chart: {
                title: chartTitle,
            },
            titleTextStyle: {
                color: '#444',
                fontSize: window.innerWidth < 600 ? 14 : 18,
                bold: true,
                fontName: "Ubuntu, sans-serif",
            },
            chartArea: {
                left: 80,
                top: 60,
                width: '80%',
                height: '70%'
            },
            hAxis: {
                titleTextStyle: { color: '#555' },
                textStyle: { color: '#333', fontSize: 11 }
            },
            vAxis: {
                minValue: 0,
                titleTextStyle: { color: '#555' },
                textStyle: { color: '#333', fontSize: 11 },
                gridlines: { color: '#eee' }
            }
        };

        var chart = new google.charts.Bar(targetDiv); // Używa diva przekazanego jako argument
        chart.draw(dataTable, google.charts.Bar.convertOptions(options)); // Rysowanie zastępuje zawartość targetDiv
        console.log("Chart drawn successfully:", targetDiv.id);

    } catch (error) {
        console.error("Error drawing chart:", targetDiv.id, error);
        // Ustawienie komunikatu błędu zastępuje zawartość targetDiv (w tym loader)
        targetDiv.innerHTML = `<p style='color: red;'>Wystąpił błąd podczas rysowania wykresu.</p><pre>${error.message}</pre>`;
    }
}
// --- Koniec: Funkcja rysująca wykres ---


// --- Początek: Konfiguracja Intersection Observer ---
document.addEventListener("DOMContentLoaded", () => {
    // ... (Bez zmian - nadal obserwuje .lazy-chart-component) ...
    const lazyChartContainers = document.querySelectorAll('.lazy-chart-component');

    if ("IntersectionObserver" in window) {
        const observerOptions = {
            root: null,
            rootMargin: '0px 0px 100px 0px',
            threshold: 0.01
        };

        let observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && entry.target.dataset.chartInitialized !== 'true') {
                    console.log("Intersection detected for chart container:", entry.target.id);
                    initializeChart(entry.target); // Wywołaj inicjalizację (która teraz tylko rysuje wykres)
                    // Nadal używamy flagi 'data-chart-initialized' zamiast unobserve
                }
            });
        }, observerOptions);

        lazyChartContainers.forEach(container => {
            observer.observe(container);
        });
        console.log(`Intersection Observer is watching ${lazyChartContainers.length} chart containers for lazy loading.`);

    } else {
        console.warn("Intersection Observer not supported. Loading all charts immediately.");
        lazyChartContainers.forEach(container => {
            if (container.dataset.chartInitialized !== 'true') {
                initializeChart(container);
            }
        });
    }
});
// --- Koniec: Konfiguracja Intersection Observer ---